import {NgModule} from '@angular/core';
import {ProviderSummaryConverter} from './api/entity/converter/providerSummary.converter';
import {ProviderConverter} from './api/entity/converter/provider.converter';

@NgModule({
    providers: [
        ProviderSummaryConverter,
        ProviderConverter,
    ],
})
export class ProviderCommonModule {
}
